import 'babel-polyfill'
import Vue from 'vue'
import './namespace'
import './sass/login.scss'
import ApplicationSettingsService from '../../common/services/src/application/applicationRemoteService'
import settings from '../../common/services/src/settings/settings';
import './services/httpInterceptor'

import vueInject from 'vue-inject';
// prepare the Service loading mechanism
import './services/vueServiceInjector'
// i18n
import en from './locales/en';
import translateService from '../../common/services/src/translate/translateService';
import '../../common/filters/translateFilter/translateFilter'

import '../favicon.ico';
import themesPlugin from '../../common/plugins/themesPlugin'
import ResourceService from "../../common/services/src/utils/resourceService";
import extensionsPlugin from "../../common/plugins/extensionsPlugin";
import LoginService from "./services/LoginService";
import App from './app/App.vue'


// FIXME i18n english only
translateService.addLanguage('en', en);

Vue.use(vueInject);
Vue.use(themesPlugin);
Vue.use(extensionsPlugin, {
	extensionContext: {},
	onRegisterExtension(name, code) {
		if(name == 'addRedirectInterceptor') {
			LoginService.addRedirectInterceptor(code);
		}
	}
});

LoginService.updateLoginData("", "", "");

if(!settings.getTenantOrganizationId()) {
	renderApp();
} else {
	ApplicationSettingsService.getApplicationSettings(settings).then((res) => {
		Promise.all([
			ResourceService.loadThemeByUrl(res.data.theme.jacadaCssUrl),
			ResourceService.loadScripts(res.data.extensionsUrls)
		]).finally(()=> {
			renderApp();
		});
	}, ()=> {
		renderApp();
	});
}


function renderApp() {
	new Vue({
		el: '#app',
		render: h => h(App)
	});
}


// WEBPACK FOOTER //
// ./src/main.js